module.exports = [
  { value: "InviteUsers", label: "Invite users", icon: "mdi-inbox" },
  { value: "InviteNewUsers", label: "Invite new users", icon: "mdi-star" },
  { value: "LoyatyClubMessage", label: "Loyaty club message" },
  { value: "CompanyMessage", label: "Company message" },
  { value: "ApproveCampaign", label: "Approve Campaign" },
  { value: "NewOrder", label: "New Order" }
];
